import React from 'react'
import { Redirect } from 'react-router-dom'
import { flags, useFeatureFlags } from 'lib/feature-flags'

function withJRLEnabled(Component) {
  function WithJRLEnabled(props) {
    const [isJRLEnabled] = useFeatureFlags([flags.FLAG_FEAT_JRL_ENABLED])

    if (!isJRLEnabled) {
      return <Redirect to="/" />
    }

    return <Component {...props} />
  }

  return WithJRLEnabled
}

export default withJRLEnabled
